import {OutlinedInput} from '@mui/material';
import Grid from '@mui/material/Grid';
import {func, number, string} from 'prop-types';

const ProductCardQuantityInput = ({quantity, handleChange, handleBlur, id}) => {
  return (
    <Grid item>
      <OutlinedInput
        id={`quantity-${id}`}
        label=""
        value={quantity}
        onChange={handleChange}
        onBlur={handleBlur}
        onKeyDown={async e => {
          e.stopPropagation();
          if (e.key === 'Enter') {
            handleBlur(e);
            e.target.blur();
          }
        }}
        sx={{
          width: {
            xs: 50,
            sm: 100
          },
          height: 38,
          mx: {xs: 0.5, sm: 1.5},
          borderRadius: '20px',
          background: 'white',
          border: '1px solid #b3bdd2',
          '& input': {textAlign: 'center'}
        }}
      />
    </Grid>
  );
};

ProductCardQuantityInput.propTypes = {
  quantity: number.isRequired,
  handleChange: func.isRequired,
  handleBlur: func.isRequired,
  id: string.isRequired
};

export default ProductCardQuantityInput;
